export const GET_URLSETUP_API_REQUEST = "GET_URLSETUP_API_REQUEST";
export const GET_URLSETUP_API_SUCCESS = "GET_URLSETUP_API_SUCCESS";
export const GET_URLSETUP_API_ERROR = "GET_URLSETUP_API_ERROR";